import { render, staticRenderFns } from "./PhoneNumberEditor.vue?vue&type=template&id=25adbfbc&scoped=true"
import script from "./PhoneNumberEditor.vue?vue&type=script&lang=js"
export * from "./PhoneNumberEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25adbfbc",
  null
  
)

export default component.exports